import React, { useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import { fetchProfile } from "../../utils/fetchProfile";
import { dataStatModules } from "../../utils/constant";
import Cookies from "js-cookie";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import EditIcon from "@mui/icons-material/Edit";
import { Slide, toast } from "react-toastify";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tooltip,
  IconButton,
  Modal,
  Box,
  Autocomplete,
  Grid,
} from "@mui/material";
import "../../style/setup.css";

const tableCellStyle = {
  whiteSpace: "nowrap",
  backgroundColor: "rgb(6,157,174)",
  color: "#FFF",
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  minWidth: 120,
  textAlign: "center",
};

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 14,
  padding: "5px 10px",
  border: "1px solid",
  width: "fit-content",
  height: "100%",
  lineHeight: 1.5,
  backgroundColor: "#069DAE",
  fontFamily: ["Roboto"].join(","),
  "&:hover": {
    backgroundColor: "#0696A6",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

function SetupBpsProvince() {
  const accessToken = Cookies.get("access_token") || "";

  const [sortBy, setSortBy] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const itemsPerPageList = [5, 10, 50, 100];
  const [totalItems, setTotalItems] = useState("");

  const [filterColumnValue, setFilterColumnValue] = useState("");

  const [dataProfile, setDataProfile] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchBarValue, setSearchBarValue] = useState("setup-bps-province");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [editDataId, setEditDataId] = useState(null);
  const [notAllowAccessPage, setNotAllowAccessPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProfile(accessToken, setDataProfile, setNotAllowAccessPage, [
        "13",
        "14",
        "TL",
        "COA",
        "A",
      ]);
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken]);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchMainData();
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken, currentPage, itemsPerPage, sortBy, sortOrder]);

  async function fetchMainData(customParams = filterColumnValue) {
    const token = Cookies.get("access_token");

    setFilteredRows([]);
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    queryParams.append("page", currentPage);
    queryParams.append("size", itemsPerPage);
    queryParams.append("sort_by", sortBy);
    queryParams.append("sort_order", sortOrder);

    if (customParams) {
      queryParams.append("column_value", customParams);
      queryParams.append("column_operator", "LIKE");
    }

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/province` +
      (queryString ? `?${queryString}` : "");

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setTotalItems(data.pagination_info.total);
        setFilteredRows(data.data);
      } else {
        setFilteredRows([]);
      }
    } catch (error) {
      setFilteredRows([]);
    }

    setIsLoading(false);
  }

  const handleTableSelection = (newValue) => {
    if (newValue) {
      setSearchBarValue(newValue.value);
      setTimeout(() => {
        window.location.href = newValue.value;
      }, 100);
    }
  };

  const handleEditClick = async (row) => {
    setEditedData(row);
    setEditDataId(row.id);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
  };

  const handleUpdateData = async () => {
    setIsLoading(true);
    if (editDataId) {
      const token = Cookies.get("access_token");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/province/${editDataId}`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(editedData),
          }
        );

        if (response.status === 200) {
          toast.success("Data berhasil diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
          setEditModalOpen(false);
          setFilterColumnValue("");
          setCurrentPage(1);
          await fetchMainData("");
        } else if (response.status == 422) {
          toast.error("Data gagal diproses!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        } else {
          const data = await response.json();
          toast.error(data.detail || "Data gagal diubah!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Slide,
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
    setIsLoading(false);
  };

  const handleResetFilter = () => {
    setFilterColumnValue("");
    setCurrentPage(1);
    fetchMainData(""); 
  };

  const handleSearch = (e) => {
    e.preventDefault();

    setCurrentPage(1);
    fetchMainData();
  };

  async function fetchExportData() {
    const token = Cookies.get("access_token");
    setIsLoading(true);

    const queryParams = new URLSearchParams();

    // if (selectedStoreType && selectedStoreType !== 'all') {
    //     queryParams.append('store_type', selectedStoreType);
    // }

    const queryString = queryParams.toString();
    const apiUrl =
      `${process.env.REACT_APP_API_URL}/api/v1/province/export` +
      (queryString ? `?${queryString}` : "");
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Result BPS Province.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else if (response.status === 404) {
        toast.error("data not found");
      } else {
        toast.error("something went wrong went export data");
      }
    } catch (error) {
      // Handle error
    }

    setIsLoading(false);
  }

  const handleExportData = async () => {
    setCurrentPage(1);
    await fetchMainData("");

    fetchExportData(accessToken, setIsLoading);
  };

  // pagination
  const handlePageChange = (event, page) => {
    setCurrentPage(page + 1);
  };

  const handleChangeItemPerPageSelect = (e) => {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  };

  // sorting
  const handleSort = (column) => {
    const isSorting = sortBy === column && sortOrder === "asc";
    setSortOrder(isSorting ? "desc" : "asc");
    setSortBy(column);
  };

  const sortTableCell = (label, sortByKey) => (
    <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>
      <TableSortLabel
        active={sortBy === sortByKey}
        direction={sortOrder}
        onClick={() => handleSort(sortByKey)}
        sx={{
          color: "#FFF !important",
          "&:hover": {
            color: "#FFF",
          },
          "& .MuiTableSortLabel-icon": {
            color: "#FFF !important",
          },
        }}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );

  if (notAllowAccessPage) {
    return (
      <div>
        <Navbar
          active="Stat Module"
          initial={dataProfile.initial}
          role_code={dataProfile.role_code}
        />
        <div>Not allowed to access this page</div>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        active="Stat Module"
        initial={dataProfile.initial}
        role_code={dataProfile.role_code}
      />
      <div style={{ padding: "1rem" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: "10px",
            marginBottom: "15px",
          }}
        >
          <Grid container spacing={0.5}>
            <Grid item xs="auto" sm="auto">
              <Autocomplete
                options={dataStatModules}
                getOptionLabel={(option) => option.label}
                value={
                  dataStatModules.find(
                    (option) => option.value === searchBarValue
                  ) || null
                }
                onChange={(e, newValue) => handleTableSelection(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cari Kategori"
                    size="small"
                    style={{ width: "300px" }}
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                disableClearable
              />
            </Grid>
            <Grid item xs="auto" sm="auto">
              <form
                onSubmit={handleSearch}
                style={{ display: "flex", alignItems: "center" }}
              >
                <TextField
                  sx={{
                    mr: 0.5,
                    height: 40,
                  }}
                  name="column_value"
                  label="Cari"
                  size="small"
                  value={filterColumnValue}
                  onChange={(e) => {
                    setFilterColumnValue(e.target.value);
                  }}
                />
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: 120, height: 40 }}
                  type="submit"
                  disabled={isLoading || !filterColumnValue}
                >
                  {isLoading ? "Loading..." : "Cari"}
                </BootstrapButton>
              </form>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                sx={{ width: 150, height: 40 }}
                onClick={handleResetFilter}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Reset Filter"}
              </BootstrapButton>
            </Grid>
            <Grid item xs="auto" sm="auto">
              <BootstrapButton
                variant="contained"
                disableRipple
                onClick={handleExportData}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Download"}
              </BootstrapButton>
            </Grid>
          </Grid>
        </div>

        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 650 }}>
            <Table
              aria-label="simple table"
              sx={{
                border: 1,
                borderColor: "grey.300",
                borderCollapse: "collapse",
              }}
            >
              <TableHead>
                <TableRow>
                  {sortTableCell("Province Code", "code")}
                  {sortTableCell("Province Name", "name")}
                  <TableCell style={tableCellStyle} sx={{ border: 1, borderColor: 'grey.300' }}>Aksi</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRows.length > 0 ? (
                  filteredRows.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>{row.code}</TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>{row.name}</TableCell>
                      <TableCell align="center" sx={{ border: 1, borderColor: 'grey.300' }}>
                        <Tooltip
                          title="Edit Data"
                          onClick={() => handleEditClick(row)}
                        >
                          <IconButton>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ border: 1, borderColor: 'grey.300' }}>
                      {isLoading ? "Loading..." : "No Data Available"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* pagination */}
          {filteredRows.length > 0 && (
            <TablePagination
              rowsPerPageOptions={itemsPerPageList}
              component="div"
              count={totalItems}
              rowsPerPage={itemsPerPage}
              page={currentPage - 1}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeItemPerPageSelect}
            />
          )}
        </Paper>

        <Modal
          open={editModalOpen}
          onClose={handleCloseEditModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ border: 0 }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: {
                xs: "90vw",
                sm: 400,
              },
              maxHeight: "90vh",
              bgcolor: "background.paper",
              border: "0px solid #000",
              boxShadow: 24,
              p: {
                xs: 2,
                sm: 4,
              },
              overflowY: "auto",
              borderRadius: 2,
            }}
          >
            <div className="edit-data">
              <h2>Edit Province</h2>
              <div>
                <TextField
                  name="code"
                  label="Code"
                  sx={{ width: "100%", mb: 2 }}
                  value={editedData.code ?? ""}
                  onChange={(e) =>
                    setEditedData({
                      ...editedData,
                      code: e.target.value,
                    })
                  }
                ></TextField>

                <TextField
                  name="name"
                  label="Name"
                  sx={{ width: "100%", mb: 2 }}
                  value={editedData.name ?? ""}
                  onChange={(e) =>
                    setEditedData({
                      ...editedData,
                      name: e.target.value,
                    })
                  }
                ></TextField>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  disableRipple
                  sx={{
                    width: "50%",
                    height: 50,
                    mt: 2,
                    color: "#b34469",
                    borderColor: "#b34469",
                  }}
                  onClick={handleCloseEditModal}
                >
                  Cancel
                </Button>
                <BootstrapButton
                  variant="contained"
                  disableRipple
                  sx={{ width: "50%", height: 50, mt: 2, mr: 0, ml: 2 }}
                  onClick={handleUpdateData}
                  disabled={isLoading}
                >
                  {isLoading ? "Loading..." : "UPDATE"}
                </BootstrapButton>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
    </div>
  );
}

export default SetupBpsProvince;
